import { Typography } from "@mui/material";
import { useIsAuthenticated } from "react-auth-kit";
import { useNavigate } from "react-router";

export default function LoadingError({ error }) {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  // navigate to login if not authenticated
  if (!isAuthenticated()) {
    navigate("/login");
    return (
      <>
        <Typography>
          Sessione scaduta! Reindirizzamento alla pagina di login...
        </Typography>
      </>
    );
  }
  return (
    <>
      <Typography>Errore durante il caricamento.</Typography>
    </>
  );
}
